import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { CookieConsentService } from '@app/core/services/cookie-consent.service';
import { SiteSeoService } from '@app/core/services/site-seo.service';
import { FooterComponent } from '@app/shared/footer/footer.component';
import { HeaderComponent } from '@app/shared/header/header.component';
import { CookieConsentBannerComponent } from '@app/shared/cookie-consent/cookie-consent-banner.component';
import { ToastHostComponent } from '@app/shared/toast/toast-host.component';

@Component({
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, CookieConsentBannerComponent, ToastHostComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'GabaliRealty';
  private readonly platformId = inject(PLATFORM_ID);

  constructor(
    private cookieConsentService: CookieConsentService,
    private siteSeoService: SiteSeoService,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.cookieConsentService.init();
    }
    this.siteSeoService.init();
  }
}
